import { createContext, useContext, ReactNode } from 'react';

type NavbarSlotContextType = {
  // eslint-disable-next-line no-unused-vars
  setSlot: (content: ReactNode | null) => void;
};

export const NavbarSlotContext = createContext<NavbarSlotContextType | null>(null);

export const useSetNavbarSlot = () => {
  const ctx = useContext(NavbarSlotContext);
  if (!ctx) throw new Error('useSetNavbarSlot must be used within a NavbarSlotContext.Provider');
  return ctx.setSlot;
};
